import React, { useState, useEffect } from "react";
import { ReportInfo } from "@shared/interfaces/ReportsFiles";
import ReportCardSkeleton from "@pages/Report/components/ReportCardSkeleton";
import ReportItem from "@pages/Project/components/Tabs/ReportsItem";
import Pagination from "@shared/components/Pagination";

interface ReportsTabProps {
  reports: ReportInfo[];
  projectId: string;
  sharedToken?: string;
  loading?: boolean;
  currentPage: number;
  totalPages: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}

const ReportsTab: React.FC<ReportsTabProps> = ({
  reports,
  projectId,
  sharedToken,
  loading = false,
  currentPage,
  totalPages,
  setCurrentPage,
}) => {
  const [reportList, setReportList] = useState<ReportInfo[]>([]);

  useEffect(() => {
    setReportList(reports);
  }, [reports]);

  const handleDelete = (reportId: string) => {
    setReportList(
      reportList.filter((report) => report.id.toString() !== reportId)
    );
  };

  return (
    <div className="flex flex-col items-start max-w-8xl py-0 mx-auto flex-1 w-full">
      {loading ? (
        <div className="flex-1 w-full">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
            {Array.from({ length: 6 }).map((_, idx) => (
              <ReportCardSkeleton key={idx} />
            ))}
          </div>
        </div>
      ) : reportList.length === 0 ? (
        <div className="flex items-center justify-center w-full flex-col my-auto">
          <img src="/no_files.png" alt="" />
          <h1 className="text-lg font-semibold mb-2 mt-4">No reports</h1>
          <p className="text-gray-400">
            When reports are generated, they will appear here.
          </p>
        </div>
      ) : (
        <>
          <div className="flex-1 w-full min-h-[60vh]">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full ">
              {reportList.map((report) => (
                <ReportItem
                  key={report.id}
                  report={report}
                  projectId={projectId}
                  onDelete={handleDelete}
                  sharedToken={sharedToken}
                />
              ))}
            </div>
          </div>

          {/* Pagination */}
        </>
      )}
      {totalPages > 1 && !loading && (
        <div className="my-8 flex justify-center space-x-2 w-full">
          <Pagination
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={setCurrentPage}
          />
        </div>
      )}
    </div>
  );
};

export default ReportsTab;
